var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkObsolete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "svg-path1 svg-fill-color",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke svg-stroke-color",
    strokeWidth: 0.3,
    d: "M20.994 36c2.573 0 5.12-.988 7.069-2.937 3.899-3.899 3.899-10.24 0-14.139-3.899-3.899-10.24-3.899-14.139 0-3.899 3.899-3.899 10.24 0 14.139A9.958 9.958 0 0 0 20.994 36zm-6.16-16.166a8.698 8.698 0 0 1 6.16-2.547 8.706 8.706 0 0 1 6.16 14.867 8.706 8.706 0 0 1-12.32 0 8.706 8.706 0 0 1 0-12.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "m19.208 29.832 3.598-2.969c.111-.105.194-.231.194-.358v-3.979c0-.294-.304-.526-.692-.526-.388 0-.692.232-.692.526v3.79l-3.432 2.8c-.25.21-.25.547.027.737a.848.848 0 0 0 .499.147c.193 0 .36-.063.498-.168z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke svg-path1 svg-fill-color svg-stroke-color",
    strokeWidth: 0.2,
    fillRule: "nonzero",
    d: "M10.815 3.185a.631.631 0 0 1 0 .893L7.893 7l2.922 2.922a.632.632 0 0 1 .067.815l-.067.078a.631.631 0 0 1-.893 0L7 7.893l-2.922 2.922a.631.631 0 0 1-.893-.893L6.107 7 3.185 4.078a.632.632 0 0 1-.067-.815l.067-.078a.631.631 0 0 1 .893 0L7 6.107l2.922-2.922a.631.631 0 0 1 .893 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkObsolete);
export default __webpack_public_path__ + "static/media/mark-obsolete.7e82da16da60c100ed55cf93347f4cfb.svg";
export { ForwardRef as ReactComponent };